import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import { PaginationRequest } from "../types"
import {
	CarbonCapturedAttributes,
	GetMaterialsResponse,
	InvoicesForMaterialItemData,
	Material,
	ProductData,
} from "./types"

export const getMaterials = (
	apiClient: APIClient,
	showTransferred: boolean,
): Promise<GetMaterialsResponse> =>
	apiClient
		.get("/materials", {
			params: { showTransferred },
		})
		.then(response => response.data)

export const getMaterialById = (
	apiClient: APIClient,
	contractNumber: string,
	materialNumber: string,
): Promise<Material> =>
	apiClient
		.get(`/materials/${materialNumber}`, {
			params: {
				contractNumber,
			},
		})
		.then(response => response.data)

export const getInvoicesForMaterialItem = (
	apiClient: APIClient,
	contractNumber: string,
	materialNumber: string,
	paginationRequest: PaginationRequest,
): Promise<InvoicesForMaterialItemData> =>
	apiClient
		.get(`materials/invoice-line-items`, {
			params: {
				contractNumber,
				materialNumber,
				...paginationRequest,
			},
		})
		.then(response => response.data)

export const getMaterialProducts = (
	apiClient: APIClient,
): Promise<ProductData> =>
	apiClient.get("/materials/descriptions").then(response => response.data)

export const getCarbonCapturedAttributes = (
	apiClient: APIClient,
	contractNumber: string,
	materialNumber: string,
): Promise<CarbonCapturedAttributes[]> =>
	apiClient
		.get(`/materials/${materialNumber}/carbon-capture-attributes`, {
			params: { contractNumber },
		})
		.then(response => response.data)

export const getCarbonCapturedAttributesByProject = (
	apiClient: APIClient,
	projectReferenceId: string,
): Promise<CarbonCapturedAttributes[]> =>
	apiClient
		.get("/materials/carbon-capture-attributes", {
			params: { projectReferenceId },
		})
		.then(response => response.data)

export const getCarbonCapturedAttributesByTransaction = (
	apiClient: APIClient,
	transactionId: string,
): Promise<CarbonCapturedAttributes[]> =>
	apiClient
		.get(
			`/materials/carbon-capture-attributes/transaction/${transactionId}`,
		)
		.then(response => response.data)
